import Model from './Model'

export default class Brand extends Model {

    schema() {
        return {
            id: null,
            shop_id: null,
            name: null,
            slug: null,
            activated: false,
            created_at: null,
            updated_at: null,
            code_comarch: null,
        }
    }

}
